<template>
    <b-modal id="modal-add-scraper" size="lg" no-close-on-backdrop>
        <template #modal-title>
            <div class="d-flex align-items-center">
                <feather-icon size="20" icon="LinkIcon" class="mr-05" />
                <span class="fs-18">Tambah Scraper WordPress</span>
            </div>
        </template>

        <loader-component v-if="is_loading" />

        <b-card no-body class="mb-0">
            <b-card-body>
                <validation-observer ref="domainRules">
                    <b-form>
                        <b-form-group label="Masukkan Domain WordPress (enter untuk input > 1)">
                            <small class="text-muted d-block">Domain setidaknya mengandung titik (.)</small>
                            <small class="text-warning d-block mb-1"><feather-icon icon="InfoIcon" size="14" class="mr-25"/> Maksimal input 25 URL / Domain sekaligus.</small>
                            <validation-provider name="Domain" rules="required" #default="{ errors }">
                                <b-form-textarea id="domain" v-model="domainText" placeholder="example.com" rows="6" />
                                <small class="text-danger" style="font-size: 10px">
                                    {{ errors[0] }}
                                </small>
                            </validation-provider>
                        </b-form-group>

                        <!-- Tabel hasil cek URL -->
                        <div v-if="scraper_data.length > 0" class="mt-1">
                            <b-table :items="scraper_data" :fields="['domain', 'status_db', 'status_request']" small
                                responsive bordered>
                                <template #cell(status_db)="data">
                                    <span :class="data.item.domain_available ? 'text-success' : 'text-danger'">
                                        {{ data.item.domain_available ? 'Belum Ada' : 'Sudah Ada' }}
                                    </span>
                                </template>
                                <template #cell(status_request)="data">
                                    <span :class="data.item.domain_request ? 'text-success' : 'text-danger'">
                                        {{ data.item.domain_request ? 'Valid' : 'Invalid' }}
                                    </span>
                                </template>
                            </b-table>
                        </div>
                    </b-form>
                </validation-observer>
            </b-card-body>
        </b-card>

        <template #modal-footer>
            <b-button variant="outline-danger" size="sm" class="float-right mr-05" @click="cancelAddScraper">
                Batal
            </b-button>
            <b-button v-if="!validated_domain" variant="outline-info" size="sm" class="float-right mr-05"
                @click="checkScraper">
                Check
            </b-button>
            <b-button v-if="validated_domain" variant="outline-success" size="sm" class="float-right"
                @click.prevent="submitScraper">
                Simpan
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import {
    BModal,
    VBModal,
    BCard,
    BCardBody,
    BForm,
    BFormGroup,
    BFormTextarea,
    BButton,
    BTable
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import floating_loader from "@/views/components/floatingLoader.vue";
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
    name: "addScraper",
    components: {
        ValidationProvider,
        ValidationObserver,
        BModal,
        BCard,
        BCardBody,
        BForm,
        BFormGroup,
        BFormTextarea,
        BButton,
        BTable,
        "loader-component": floating_loader,
    },
    data() {
        return {
            is_loading: false,
            domainText: "",
            scraper_data: [],
            validated_domain: false,
            checkButton: false,
            required,
        };
    },
    watch: {
        "domainText"() {
            if (this.validated_domain) {
                this.checkScraper();
            }
        }
    },
    methods: {
        checkScraper() {
            this.$refs.domainRules.validate().then((success) => {
                if (success) {
                    this.is_loading = true;
                    const domains = this.domainText
                        .split("\n")
                        .map((domain) => domain.trim())
                        .filter((domain) => domain !== "");
                    this.scraper_data = [];

                    let api = process.env.VUE_APP_API_URL + "wordpress/check";

                    const requestData = {
                        data: domains.map((domain) => ({ domain })),
                    };

                    useJwt.axiosIns
                        .post(api, requestData)
                        .then((res) => {
                            if (res.data.message) {
                                this.scraper_data = res.data.results.map((item) => ({
                                    domain: item.domain,
                                    domain_available: !item.exists,
                                    domain_request: item.reachable,
                                }));

                                let message = res.data?.message
                                this.$toast({
                                    component: ToastificationContent,
                                    position: "top-center",
                                    props: {
                                        title: "Gagal",
                                        icon: "AlertTriangleIcon",
                                        variant: "danger",
                                        text: message,
                                    },
                                });
                            } else {
                                this.scraper_data = res.data.results.map((item) => ({
                                    domain: item.domain,
                                    domain_available: !item.exists,
                                    domain_request: item.reachable,
                                }));
                            }

                            this.validated_domain = this.scraper_data.every(
                                (item) => item.domain_available && item.domain_request
                            );
                            this.checkButton = true;
                        })
                        .catch((err) => {
                            console.error("Gagal cek URL:", err);
                            this.scraper_data = domains.map((domain) => ({
                                domain,
                                domain_available: false,
                                domain_request: false,
                            }));
                            this.validated_domain = false;
                        })
                        .finally(() => {
                            this.is_loading = false;
                        });
                }
            });
        },
        submitScraper() {
            this.$refs.domainRules.validate().then((success) => {
                if (success && this.validated_domain) {
                    this.is_loading = true;

                    const validDomains = this.scraper_data
                        .filter((item) => item.domain_available)
                        .map((item) => item.domain);

                    const requestData = {
                        data: validDomains.map((domain) => ({ domain }))
                    }

                    const api = process.env.VUE_APP_API_URL + "wordpress/add";

                    useJwt.axiosIns
                        .post(api, requestData)
                        .then((res) => {
                            const message = res.data.message || "Scraper berhasil ditambahkan.";
                            this.domainText = "";
                            this.scraper_data = [];
                            this.validated_domain = false;
                            this.$bvModal.hide("modal-add-scraper");
                            this.$parent.getData();
                            this.$toast({
                                component: ToastificationContent,
                                position: "top-right",
                                props: {
                                    title: "Berhasil",
                                    icon: "CheckCircleIcon",
                                    variant: "success",
                                    text: message,
                                },
                            });
                        })
                        .catch((err) => {
                            const message = err.response?.data?.detail?.message || "Gagal menambahkan scraper.";
                            this.$toast({
                                component: ToastificationContent,
                                position: "top-right",
                                props: {
                                    title: "Gagal",
                                    icon: "AlertTriangleIcon",
                                    variant: "danger",
                                    text: message,
                                },
                            });
                        })
                        .finally(() => {
                            this.is_loading = false;
                            this.checkButton = false;
                        });
                }
            });
        },

        cancelAddScraper() {
            this.domainText = "";
            this.scraper_data = [];
            this.validated_domain = false;
            this.$bvModal.hide("modal-add-scraper");
            this.checkButton = false;
        },
    },
    directives: {
        "b-modal": VBModal,
    },
};
</script>

<style scoped>
.modal-title {
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 20px !important;
    font-weight: bold;
}
</style>
